// redux/slices/uiSlice.js
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SidebarTab = 'cases' | 'chats'; // DELETED: 'courtResearch'
export type ViewMode = 'grid' | 'list';

interface UiState {
    isMobile: boolean;
    expandedCitations: Record<string, boolean>;
    activeSidebarTab: SidebarTab;
    viewMode: ViewMode;
    // DELETED: currentCourtResearchResultId: string | null;
    showConversations: boolean;
    showDocumentSearches: boolean;
}

const initialState: UiState = {
    isMobile: false,
    expandedCitations: {}, // Object with citation IDs as keys and boolean as values
    activeSidebarTab: 'cases', // Default to chats tab
    viewMode: 'grid',
    // DELETED: currentCourtResearchResultId: null,
    showConversations: true, // Default to showing conversations
    showDocumentSearches: true, // Default to showing document searches
};

const UISlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setIsMobile: (state, action: PayloadAction<boolean>) => {
            state.isMobile = action.payload;
        },
        toggleCitation: (state, action: PayloadAction<string>) => {
            const citationId = action.payload;
            state.expandedCitations[citationId] = !state.expandedCitations[citationId];
        },
        setActiveSidebarTab: (state, action: PayloadAction<SidebarTab>) => {
            state.activeSidebarTab = action.payload;
        },
        setViewMode: (state, action: PayloadAction<ViewMode>) => {
            state.viewMode = action.payload;
        },
        // DELETED: setCurrentCourtResearchResultId: (state, action: PayloadAction<string | null>) => { ... },
        toggleShowConversations: (state) => {
            state.showConversations = !state.showConversations;
        },
        toggleShowDocumentSearches: (state) => {
            state.showDocumentSearches = !state.showDocumentSearches;
        }
    },
});


export const {
    setIsMobile,
    toggleCitation,
    setActiveSidebarTab,
    setViewMode,
    // DELETED: setCurrentCourtResearchResultId,
    toggleShowConversations,
    toggleShowDocumentSearches
} = UISlice.actions;

export default UISlice.reducer;